// extracted by css-extract-rspack-plugin
export default {"cls1":"ReferenceEvaluationPage-cls1_oqx","cls2":"ReferenceEvaluationPage-cls2_kcC ReferenceEvaluationPage-cls1_oqx"};